import './styles/Filter.css';
import Filter from './Filter';

export default Filter;
